<template>
	<virtual-scroller v-show="show && showMembers.length" ref="scroller" class="chat-at-box"
		:style="{ 'left': pos.x + 'px', 'top': pos.y - 300 + 'px' }" :items="showMembers">
		<template v-slot="{ item }">
			<group-member-item :group="group" :groupMembers="members" :member="item" :height="40"
				:active="activeMember && item.userId === activeMember.userId" :menu="false"
				@click.native="onSelectMember(item)"></group-member-item>
		</template>
	</virtual-scroller>
</template>

<script>
import VirtualScroller from "../common/VirtualScroller.vue";
import GroupMemberItem from "../group/GroupMemberItem.vue";

export default {
	name: "chatAtBox",
	components: { VirtualScroller, GroupMemberItem },
	props: {
		searchText: { type: String, default: "" },
		group: { type: Object },
		members: { type: Array }
	},
	data() {
		return {
			show: false,
			pos: { x: 0, y: 0 },
			activeIdx: 0
		};
	},
	computed: {
		showMembers() {
			const list = [];
			const userId = this.userStore.userInfo.id;
			const allName = this.$t('chat.allMembers');
			if (this.group.ownerId == userId && allName.startsWith(this.searchText)) {
				list.push({ userId: -1, showNickName: allName });
			}
			this.members.forEach(m => {
				if (m.userId != userId && !m.quit && m.showNickName.startsWith(this.searchText)) {
					list.push(m);
				}
			});
			return list;
		},
		activeMember() {
			return this.showMembers[this.activeIdx];
		}
	},
	methods: {
		scrollWrap() {
			const s = this.$refs.scroller;
			return s && s.$refs.scrollbar && s.$refs.scrollbar.wrap;
		},
		init() {
			this.activeIdx = this.showMembers.length ? 0 : -1;
			this.$nextTick(() => {
				const scroller = this.$refs.scroller;
				if (scroller) {
					scroller.init();
					const wrap = this.scrollWrap();
					if (wrap) wrap.scrollTop = 0;
				}
			});
		},
		open(pos) {
			this.show = true;
			this.pos = pos;
			this.init();
		},
		close() {
			this.show = false;
		},
		moveUp() {
			if (this.activeIdx > 0) {
				this.activeIdx--;
				this.scrollToActive();
			}
		},
		moveDown() {
			if (this.activeIdx < this.showMembers.length - 1) {
				this.activeIdx++;
				this.scrollToActive();
			}
		},
		select() {
			if (this.activeMember) {
				this.onSelectMember(this.activeMember);
			}
			this.close();
		},
		scrollToActive() {
			const scroller = this.$refs.scroller;
			if (scroller) {
				scroller.page = Math.max(scroller.page, Math.ceil((this.activeIdx + 1) / scroller.size));
			}
			this.$nextTick(() => {
				const wrap = this.scrollWrap();
				if (!wrap) return;
				const top = this.activeIdx * 40;
				if (top - wrap.clientHeight > wrap.scrollTop) {
					wrap.scrollTop = Math.min(wrap.scrollTop + 140, wrap.scrollHeight);
				} else if (top < wrap.scrollTop) {
					wrap.scrollTop = Math.max(wrap.scrollTop - 140, 0);
				}
			});
		},
		onSelectMember(member) {
			this.$emit("select", member);
			this.show = false;
		}
	},
	watch: {
		searchText() {
			this.init();
		}
	}
}
</script>

<style scoped lang="scss">
.chat-at-box {
	position: fixed;
	width: 200px;
	height: 300px;
	background-color: #fff;
	box-shadow: var(--im-box-shadow);
	border-radius: 6px;
	overflow: hidden;
}
</style>
